import { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Trash } from 'lucide-react';

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator
} from '@/components/ui/breadcrumb';
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
  CardFooter
} from '@/components/ui/card';
import { Button } from '@/components/ui/button';

import { useTenant } from '@/data/tenant';
import Loader from '@/components/common/Loader';
import DeleteTenantDialog from './view/DeleteTenantDialog';

const View = () => {
  const params = useParams();
  const tenant = useTenant(params.tenantId);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

  if (tenant.isLoading && !tenant.data) {
    return (
      <div className="h-[calc(100vh-60px)]">
        <Loader />
      </div>
    );
  }

  return (
    <>
      <Breadcrumb className="mb-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to="/tenant">Tenants</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>{tenant.data.name}</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      <Card>
        <CardHeader>
          <CardTitle className="flex justify-between items-center mb-4">
            {tenant.data.name}
          </CardTitle>
          <CardDescription>Edit or View this tenant.</CardDescription>
        </CardHeader>
        <CardContent>
          This is where we would be able to edit the tenant
        </CardContent>
        <CardFooter className="flex justify-end">
          <Button
            variant="destructive"
            onClick={() => setIsDeleteDialogOpen(true)}
          >
            <Trash />
            Delete Tenant
          </Button>
        </CardFooter>
      </Card>
      {isDeleteDialogOpen && (
        <DeleteTenantDialog
          tenant={tenant.data}
          setOpen={setIsDeleteDialogOpen}
        />
      )}
    </>
  );
};

export default View;
